import {Component, OnInit} from '@angular/core';
import {Block, BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-header2',
    templateUrl: './block-header2.component.html',
})

export class BlockHeader2Component extends BlockAbstractComponent implements OnInit {

    parseBlockId(block: Block) {
        if (block.data.isAnchor) {
            return this.block.data.text.toLowerCase().replace(/\s+/g, '-');
        } else {
            return 'heading-' + block.id
        }
    }

}
